export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00203.734a5fc4.png";